import { render } from "./AsahiRadioButton.vue?vue&type=template&id=b62289de&scoped=true"
import script from "./AsahiRadioButton.vue?vue&type=script&lang=js"
export * from "./AsahiRadioButton.vue?vue&type=script&lang=js"

import "./AsahiRadioButton.vue?vue&type=style&index=0&id=b62289de&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62289de"]])

export default __exports__